import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../Service/axiosInstance";
import ListePays from "./Fonction/ListePays";
import { Button } from '@mui/material';

function Footer() {
  const navigate = useNavigate();
  const [typeOffre, setTypeOffre] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [email, setEmail] = useState("");
  const [nom, setNom] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => { 
    axiosInstance
      .get("/yourtravelshop/typeOffre/liste")
      .then((response) => {
        setTypeOffre(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des packages :", error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!selectedCountry) {
      alert("Veuillez sélectionner un pays.");
      return;
    }
  
    const formData = {
      nom: nom,
      email: email,
      telephone: phone,
      message: message,
      pays: {
        idPays: selectedCountry.id, // vérifie que c'est bien le bon champ
        nom: selectedCountry.nom
      }
    };
  
    axiosInstance
      .post("/yourtravelshop/messagerie", formData)
      .then((response) => {
        alert("Message envoyé avec succès !");
        setNom("");
        setEmail("");
        setPhone("");
        setMessage("");
        setSelectedCountry(null); // reset du pays sélectionné
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi du message :", error);
        alert("Erreur lors de l'envoi du message.");
      });
  };
  


  return (
    <footer className="footer" id="contact_messagerie">
      <div className="container">
        <div className="row">
          {/* Footer Column */}
          <div className="col-lg-3 footer_column">
            <div className="footer_col">
              <div className="footer_content footer_about">
                <div className="logo_container footer_logo">
                  <div className="logo">
                    <a href="#">
                    <img
                      src="/assets/images/logoH.png"
                      alt="Your Travel Shop"
                      style={{
                        width: '40px',  // Ajuste cette valeur pour la largeur du logo
                        height: 'auto',  // Maintient le ratio de l'image
                      }}
                    />
                  <span style={{
                  fontFamily: 'Dancing Script, cursive',
                  fontSize: '30px',
                  marginLeft: '5px',
                  textTransform: 'none',
                  wordSpacing: '5px' // ajuste selon le rendu souhaité
                }}>
                  Your Travel Shop
                </span>
                    </a>
                  </div>
                </div>
                <p className="footer_about_text">
  			Your Travel Shop, lancé par Madagascar Discovery Agency, contribue au développement du tourisme à Madagascar en facilitant la réservation et la planification de voyages grâce à une plateforme numérique accessible et conviviale.
		</p>
                <ul className="footer_social_list">
                  <li className="footer_social_item">
                    <a href="https://www.facebook.com/people/Your-Travel-Shop/61556457474196">
                      <i className="fa fa-facebook-f" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
{/* Footer Column */}
<div className="col-lg-3 footer_column">
  <div className="footer_col">
    <div className="footer_title">Contactez-nous</div>
    <div className="footer_content">
          <form onSubmit={handleSubmit}>
  <div className="form-group">
    <label htmlFor="footerNom">Nom :</label>
    <input
      type="text"
      className="form-control"
      id="footerNom"
      value={nom}
      onChange={(e) => setNom(e.target.value)}
      placeholder="Entrez votre nom"
      required
      style={{ backgroundColor: 'white', color: 'black' }}
    />
  </div>

  <div className="form-group">
    <label htmlFor="footerPays">Lieu de naissance :</label>
    <ListePays
      selectedCountry={selectedCountry}
      onSelectCountry={setSelectedCountry}
      sx={{
        input: { backgroundColor: 'white', color: 'black' },
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
        }
      }}
    />
  </div>

  <div className="form-group">
    <label htmlFor="footerEmail">Email :</label>
    <input
      type="email"
      className="form-control"
      id="footerEmail"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Entrez votre email"
      required
      style={{ backgroundColor: 'white', color: 'black' }}
    />
  </div>

  <div className="form-group">
    <label htmlFor="footerPhone">Numéro de téléphone :</label>
    <input
      type="tel"
      className="form-control"
      id="footerPhone"
      value={phone}
      onChange={(e) => setPhone(e.target.value)}
      placeholder="Entrez votre numéro"
      required
      style={{ backgroundColor: 'white', color: 'black' }}
    />
  </div>

  <div className="form-group">
    <label htmlFor="footerMessage">Message :</label>
    <textarea
      className="form-control"
      id="footerMessage"
      rows="3"
      value={message}
      onChange={(e) => setMessage(e.target.value)}
      placeholder="Votre message"
      required
      style={{ backgroundColor: 'white', color: 'black' }}
    ></textarea>
  </div>

  <button
  type="submit"
  className="btn btn-primary"
  style={{ cursor: 'pointer' }}
>
  Envoyer
</button>

</form>

    </div>
  </div>
</div>

          {/* Footer Column */}
          <div className="col-lg-3 footer_column" id="type-offres-footer">
              <div className="footer_col">
                <div className="footer_title">Type d'offres</div>
                <div className="footer_content footer_tags">
                  <ul>
                    {typeOffre.length > 0 ? (
                      typeOffre.map((offre) => (
                        <li
                          key={offre.id}
                          onClick={() => navigate(`/type-offres/${offre.id}`)}
                          style={{ 
                            cursor: "pointer", 
                            listStyleType: "disc", // Ajoute un point devant chaque élément
                            marginBottom: "5px", // Espacement entre les éléments
                            textDecoration: "none", // Pas de soulignement par défaut
                            color: "white"
                          }}
                          onMouseEnter={(e) => e.target.style.textDecoration = "underline"} // Soulignement au survol
                          onMouseLeave={(e) => e.target.style.textDecoration = "none"} // Retire le soulignement en quittant
                        >
                          {offre.nom}
                        </li>
                      ))
                    ) : (
                      <li style={{ listStyleType: "disc" }}>
                        Aucune offre disponible
                      </li>
                    )}
                  </ul>
                </div>
              </div>
          </div>

          {/* Footer Column */}
          <div className="col-lg-3 footer_column">
            <div className="footer_col">
              <div className="footer_title"> Information </div>
              <div className="footer_content footer_contact">
                <ul className="contact_info_list">
                  <li className="contact_info_item d-flex flex-row">
                    <div>
                      <div className="contact_info_icon">
                        <img src="assets/images/placeholder.svg" alt="" />
                      </div>
                    </div>
                    <div className="contact_info_text">
                      Dyve Garden Anosivavaka (3ème étage) ~ Antananarivo, Madagascar
                    </div>
                  </li>
                  <li className="contact_info_item d-flex flex-row">
                    <div>
                      <div className="contact_info_icon">
                        <img src="assets/images/phone-call.svg" alt="" />
                      </div>
                    </div>
                    <div className="contact_info_text">+261 (0) 38 77 432 66</div>
                  </li>
                  <li className="contact_info_item d-flex flex-row">
                    <div>
                      <div className="contact_info_icon">
                        <img src="assets/images/message.svg" alt="" />
                      </div>
                    </div>
                    <div className="contact_info_text">
                      <a
                        href="mailto:contactme@gmail.com?Subject=Hello"
                        target="_top"
                      >
                        
                      yts@madagascar-discovery.com
                      </a>
                    </div>
                  </li>
                  <li className="contact_info_item d-flex flex-row">
                    <div>
                      <div className="contact_info_icon">
                        <img src="assets/images/planet-earth.svg" alt="" />
                      </div>
                    </div>
                    <div className="contact_info_text">
                      <a href="https://colorlib.com">www.madagascar-discovery.mg</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
	<div style={{ textAlign: 'center', fontSize: '14px', color: '#555', marginTop: '20px' }}>
        &copy; {new Date().getFullYear()} All rights reserved Madagascar Discovery Agency
      </div>
    </footer>
  );
}

export default Footer;
